import { render, staticRenderFns } from "./updatePost.vue?vue&type=template&id=12be52ad&scoped=true&"
import script from "./updatePost.vue?vue&type=script&lang=js&"
export * from "./updatePost.vue?vue&type=script&lang=js&"
import style0 from "./updatePost.vue?vue&type=style&index=0&id=12be52ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be52ad",
  null
  
)

export default component.exports